var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('bar-chart',{attrs:{"chart-data":_vm.chartData,"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }